import Cookies from 'js-cookie';
import IOS from 'components/PWA/IOS';
import NewBottomSheet from 'components/BottomSheet';
import React from 'react';
import useWhiteLabelProject from 'Hook/useEntkhabino';
import { Typography } from '@material-ui/core';
import { useLocation } from 'react-router';
import { PLATFORM, PWA_INSTALLED } from 'services/PWA';
import { booleanParser } from 'services/booleanParser';

const withPWA = (ComposedComponent) => {
	return (hocProps) => {
		const { pathname } = useLocation();
		const { isWhiteLabelDomain } = useWhiteLabelProject();

		const initialValue = booleanParser(Cookies.get('seen_installed_pwa'))
			? JSON.parse(Cookies.get('seen_installed_pwa'))
			: PWA_INSTALLED;

		const [seenPWA, setSeenPWA] = React.useState(initialValue || false);

		React.useEffect(() => {
			Cookies.set('seen_installed_pwa', JSON.stringify(seenPWA), { expires: 300 });
		}, [seenPWA]);

		if (!['/', '/auth/login'].includes(pathname) || ['android', 'unknown'].includes(PLATFORM)) {
			return <ComposedComponent {...hocProps} />;
		}

		return (
			<>
				<ComposedComponent {...hocProps} />

				{['ios'].includes(PLATFORM) && (
					<NewBottomSheet
						noPadding={false}
						onDismiss={() => setSeenPWA(true)}
						header={
							<Typography
								style={{
									fontSize: '21px',
									color: '#25233D',
									textAlign: 'right',
									fontWeight: 700,
									margin: '16px 0 0px 0',
								}}
							>
								نصب نسخه وب اپلیکیشن {isWhiteLabelDomain ? '' : 'کیپا'}
							</Typography>
						}
						opening={!seenPWA}
					>
						{({ handleClose }) => <IOS handleClose={handleClose} setSeenPWA={setSeenPWA} />}
					</NewBottomSheet>
				)}
			</>
		);
	};
};

export default withPWA;
